/**
 * Init routes
 */
export const initRoutes = () => {
    const routes = window.Laravel.Routes;
    Object.keys(routes).map((name) => {
        setsRouteByName(name, routes[name].vueRoute)
    })
}

/**
 * Get Route by name
 * @param {string} name
 */
export const getsRouteByName = (name = "") => window.Laravel.vueLinks[name]

/**
 * Set Vue route by name
 * @param {string} name
 * @param {string} url
 */
export const setsRouteByName = (name, url) => {
    window.Laravel.vueLinks[name] = url
};